export default __webpack_public_path__ + "static/media/gaana_social.d76fa166.png";